import { SkinnableComponent } from '../../../types/component-skin';
import { COMPONENT_TYPES } from '../../../constants';
import useProductSliderLogic from './ProductSliderLogic';
import BasicProductSliderSkin from './skins/BasicProductSliderSkin';

export const ProductSliderSkinnable: SkinnableComponent = {
  type: COMPONENT_TYPES.PRODUCT_SLIDER || 'ProductSlider',
  name: '상품 슬라이더',
  category: 'ecommerce',
  supportsExternalSkins: true,
  options: [
    {
      key: 'autoSlide',
      type: 'boolean',
      label: '자동 슬라이드',
      defaultValue: true
    },
    {
      key: 'showTitle',
      type: 'boolean', 
      label: '제목 표시',
      defaultValue: true
    },
    {
      key: 'showPrice',
      type: 'boolean',
      label: '가격 표시',
      defaultValue: true
    },
    {
      key: 'showAddToCart',
      type: 'boolean',
      label: '장바구니 버튼 표시',
      defaultValue: true
    },
    {
      key: 'showStock',
      type: 'boolean',
      label: '재고 표시',
      defaultValue: false
    }
  ],
  defaultSkin: 'basic',
  internalSkins: {
    basic: BasicProductSliderSkin as any
  },
  useLogic: useProductSliderLogic as any,
  defaultProps: {
    sliderTitle: '인기 상품',
    showTitle: true,
    titleFontSize: '18px',
    titleFontWeight: '600',
    titleColor: '#333',
    itemsPerSlide: 4,
    autoSlide: true,
    autoSlideInterval: 3000,
    showStock: false,
    showAddToCart: true,
    showPrice: true,
    cartButtonColor: '#007bff',
    skin: 'basic'
  }
};